import clsx from 'clsx'
import { DateObject } from 'react-multi-date-picker'

import { Value } from '.'
import classes from './speed-dial-section.module.scss'
import { areDateRangesEqual } from './utilities'

export interface SpeedDial<T extends Value = Value> {
  label: string
  value: T
}
export type SpeedDialRange = SpeedDial<[Date, Date]>
export type SpeedDialDate = SpeedDial<Date>

interface SpeedDialSectionProps {
  onChange: (value: any) => void
  speedDials: SpeedDial[]
  value: Value | null
  variant: 'single' | 'range'
}

export const SpeedDialSection = ({
  onChange,
  speedDials,
  value,
  variant
}: SpeedDialSectionProps) => (
  <ul className={classes.root}>
    {speedDials.map(({ label, value: speedDialValue }) => {
      const isActive =
        value && variant === 'range'
          ? areDateRangesEqual(value as [Date, Date], speedDialValue as [Date, Date])
          : new DateObject(value as Date).toString() ===
            new DateObject(speedDialValue as Date).toString()
      return (
        <li key={label}>
          <button
            className={clsx(classes.button, {
              [classes.active]: isActive
            })}
            type="button"
            onClick={() =>
              onChange(
                variant === 'range'
                  ? [new DateObject(speedDialValue[0]), new DateObject(speedDialValue[1])]
                  : new DateObject(speedDialValue as Date)
              )
            }
          >
            {label}
          </button>
        </li>
      )
    })}
  </ul>
)
